const userStore = {
  namespaced: true,
  state() {
    return {
      firstName: '',
      lastName: '',
      role: 0,
      id: '',
      job: '',
      roleId: 0,
    }
  },
  mutations: {
    SET_USER(state, payload) {
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.role = payload.role;
      state.id = payload.id;
      state.job = payload.job;
      state.roleId = payload.roleId
    }
  },
  actions: {
    setUser({commit}, {firstName, lastName, role, id, job, roleId}) {
      commit('SET_USER', {
        firstName,
        lastName,
        role,
        id,
        job,
        roleId
      })
    }
  },
  getters: {
    getFullName(state) {
      return state.firstName + " " + state.lastName
    }
  }
}

export default userStore